// ...existing code...
import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Blog.css";

const API_ROOT = "https://legalexpertsindia.in";

function Blog() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => { fetchBlogs(); }, []);

  const fetchBlogs = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get(`${API_ROOT}/api/blogs`);
      setBlogs(res.data || []);
    } catch (err) {
      console.error(err);
      setError("Could not load posts");
    } finally {
      setLoading(false);
    }
  };

  const normalizeImageSrc = (img) => {
    if (!img) return null;
    if (img.startsWith("http://") || img.startsWith("https://")) return img;
    return `${API_ROOT}${img.startsWith("/") ? "" : "/"}${img}`;
  };

  return (
<div>

      <img src="/blog.jpg" alt="Header" />

      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        {loading && <p>Loading...</p>}
        {error && <p style={{ color: "red" }}>{error}</p>}
        {blogs.length === 0 && !loading && <p>No posts yet.</p>}

        <div style={{ display: "grid", gap: 16 }}>
          {blogs.map((b) => (
            <article key={b.id || b._id || b.title} style={{ display: "flex", gap: 12, padding: 12, borderRadius: 8, boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
             {b.image ? (
  <div className="blog-image-wrapper">
    <img
      src={`https://legalexpertsindia.in/api${b.image}`}
      alt={b.title}
      className="blog-image"
      onError={(e) => {
        e.currentTarget.style.display = "none";
      }}
    />
  </div>
) : null}

              <div>
                <h3 style={{ margin: "0 0 8px" }}>{b.title}</h3>
                <p style={{ margin: 0 }}>{b.content?.length > 100000 ? `${b.content.slice(0, 100000)}...` : b.content}</p>
                {b.createdAt && (
  <small style={{ color: "#090808" }}>
    {new Date(b.createdAt).toLocaleDateString("en-GB")}
  </small>
)}
              </div>
            </article>
          ))}
        </div>
      </div>

     <div className="links-container">
          <div className="links-box">
            <h3>Residence/Office - anishsrivastava01@gmail.com</h3>
            <p className="address-black">
              S-1, Block-2, Gopal Tirath Plaza, Indira Nagar
            </p>
            <p className="address-black">
              Metro Station, Lucknow, Uttar Pradesh - 226016
            </p>
          </div>

          <div className="links-box">
            <h3>Chamber - legalexpertsindia.in@gmail.com</h3>
            <p className="address-black">
              Chamber No. E 105, Lawyers Chamber, E Block
            </p>
            <p className="address-black">
              High Court Campus, Gomtinagar, Lucknow
            </p>
            <p className="address-black">Mobile :- +91 9415425437</p>
          </div>
        </div>

    </div>
  );
}

export default Blog;
// ...existing code...
